module.exports = __webpack_public_path__ + "assets/PTS55F-webfont.df8dca9c66dcd340eeb9de84e6c06f93c33e5b502acf89cd51cfb70a18022149.woff2";